import {css, CSSObject, Interpolation} from 'styled-components';

interface Size {
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
}

export const size: Size = {
    xs: 320,
    sm: 768,
    md: 1024,
    lg: 1200,
    xl: 1440,
};

// hoc to create media query
export const createMediaQuery = (query: string) => {
    // note: We use a generic <T> to represent the Props
    const mediaQuery = <T extends object>(
        strings: TemplateStringsArray | CSSObject,
        ...interpolations: Interpolation<T>[]
    ) => {
        return css<T>`
            @media ${query} {
                ${css(strings, ...interpolations)}
            }
        `;
    };

    return mediaQuery;
};

// Please add more as required
export const portrait = createMediaQuery('(orientation: portrait)');
export const landscape = createMediaQuery('(orientation: landscape)');
export const mobile = createMediaQuery(`(max-width: ${size.sm - 1}px)`);
export const tablet = createMediaQuery(
    `(min-width: ${size.sm}px) and (max-width: ${size.md}px) and (pointer: coarse)`
);

export const mobilePortrait = createMediaQuery(
    `(max-width: ${size.sm}px) and (orientation: portrait) and (pointer: coarse)`
);
export const mobileLandscape = createMediaQuery(
    `(max-width: ${size.md - 1}px) and (orientation: landscape) and (pointer: coarse)`
);

export const tabletPortrait = createMediaQuery(
    `(min-width: ${size.sm}px) and (pointer: coarse) and (orientation: portrait)`
);
export const tabletLandscape = createMediaQuery(
    `(min-width: ${size.md}px) and (pointer: coarse) and (orientation: landscape)`
);

export const smallDesktops = createMediaQuery(
    `(min-width: 1370px) and (max-width: 1800px)`
);

export const smallDevices = createMediaQuery(
    `(min-width: ${size.sm}px) and (max-width: 1369px)`
);

export const portraitDevices = <T extends object>(
    styles: TemplateStringsArray | CSSObject,
    ...interpolations: Interpolation<T>[]
) => css`
    ${mobilePortrait<T>(styles, ...interpolations)}
    ${tabletPortrait<T>(styles, ...interpolations)}
`;

export const mobileLandscapeAndPortraitDevices = <T extends object>(
    styles: TemplateStringsArray | CSSObject,
    ...interpolations: Interpolation<T>[]
) => css`
    ${mobilePortrait<T>(styles, ...interpolations)}
    ${mobileLandscape<T>(styles, ...interpolations)}
    ${tabletPortrait<T>(styles, ...interpolations)}
`;

export const tablets = <T extends object>(
    styles: TemplateStringsArray | CSSObject,
    ...interpolations: Interpolation<T>[]
) => css`
    ${tabletPortrait<T>(styles, ...interpolations)}
    ${tabletLandscape<T>(styles, ...interpolations)}
`;

export const touchDevices = <T extends object>(
    styles: TemplateStringsArray | CSSObject,
    ...interpolations: Interpolation<T>[]
) => css`
    ${mobilePortrait<T>(styles, ...interpolations)}
    ${mobileLandscape<T>(styles, ...interpolations)}
    ${tabletPortrait<T>(styles, ...interpolations)}
    ${tabletLandscape<T>(styles, ...interpolations)}
`;

export const nonTouchDevices = createMediaQuery('(pointer: fine)');
